import React from 'react';
import PropTypes from 'prop-types';

import t from '../lib/I18n';
import config from '../config';
import appVersion from '../appVersion';
import reportError, {
    init as initErrorReporter
} from '../helpers/ErrorReporter';
import {
    Browsers,
    GlobalModals as GlobalModalType,
    IgnoredErrors
} from '../constants/AppConstants';
import { browserDetection } from '../helpers/DeviceDetection';

import ModalActions from '../actions/ModalActions';
import ErrorModal from './general/ErrorModal';

const errorHandler = function(...args) {
    const e = args.length === 5 ? args.pop() : args.shift();
    let error = e.detail ? e.detail.reason : e;
    const shouldIgnore =
        typeof e.message === 'string' &&
        IgnoredErrors.some(errorPattern => e.message.match(errorPattern));

    const isRefreshTokenError = error && error.name && error.name === 'RefreshTokenError';

    const isCookiebotConsentRequestIssue = error && error.reason && error.reason.includes
        && error.reason.includes('Failed to fetch')
        && error.reason.includes('googletagmanager.com')
        && error.reason.includes('consent.cookiebot.com')
        && error.reason.includes('consentmode');

    if (!shouldIgnore && !isRefreshTokenError && !isCookiebotConsentRequestIssue) {
        console.error('Error boundary caught: ', error);
        ModalActions.open(GlobalModalType.ERROR, { error });
    }
    const hasErrorEvent = typeof ErrorEvent !== 'undefined';
    if (!(hasErrorEvent && error instanceof ErrorEvent)) {
        reportError(error);
    }
};

export default class GlobalErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.any
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    state = {
        hasError: false,
        isRefreshing: false
    };

    componentDidMount() {
        const canUseRavenSDK = !config.get('debug') && browserDetection() !== Browsers.IOS_CHROME;

        if (canUseRavenSDK) {
            initErrorReporter(appVersion.version);
        }
        window.addEventListener('error', errorHandler);
        window.addEventListener('unhandledrejection', errorHandler);
    }

    componentDidCatch(error) {
        errorHandler(error);
    }

    componentWillUnmount() {
        window.removeEventListener('error', errorHandler);
        window.removeEventListener('unhandledrejection', errorHandler);
    }

    continue = () => {
        this.setState({ hasError: false });
    };

    refresh = () => {
        this.setState({ hasError: false, isRefreshing: true });
        window.location.reload();
    };

    render() {
        if (this.state.isRefreshing) {
            return (
                <div className="margin-top padding-top loading text-center loading--standalone">
                    <span className="otrl circle-spinner" />
                    <h2 className="no-margin">{t('global.loading')}</h2>
                </div>
            );
        }
        if (this.state.hasError) {
            return (
                <ErrorModal
                    closeText="button.text.continue"
                    onClose={ this.continue }
                    customButton={ {
                        text: 'button.text.refresh',
                        onClick: this.refresh
                    } }
                />
            );
        }
        return this.props.children;
    }
}



// WEBPACK FOOTER //
// ./src/components/GlobalErrorBoundary.js